import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { fetchItemsOfConcern } from "../api/enterpriseClient";

export const itemsOfConcernQueryOptions = (customerId: number) =>
  queryOptions({
    queryKey: ["enterprise-items-of-concern", customerId],
    queryFn: () => fetchItemsOfConcern(customerId),
    staleTime: 5 * 60_000,
  });

export function useGetItemsOfConcern(customerId: number) {
  return useSuspenseQuery(itemsOfConcernQueryOptions(customerId));
}
